import { render, staticRenderFns } from "./CookieComponent.vue?vue&type=template&id=0418687e"
import script from "./CookieComponent.vue?vue&type=script&lang=js"
export * from "./CookieComponent.vue?vue&type=script&lang=js"
import style0 from "./CookieComponent.vue?vue&type=style&index=0&id=0418687e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports